<template>
  <div class="form-group" v-show="showFilters">
      <ul class="active-filter-list">
          <li v-for="filter in filters"
              :key="filter.Id">
              <a href="#" @click="removeFilter(filter, $event)">
                  {{ filter.Name }}
                  <span class="glyphicon glyphicon-remove-sign"></span>
              </a>
          </li>
          <li>
              <a href="#clearAll" id="clear-all" @click="clearFilters($event)">
                  {{ getLabel('clearall') }}
                  <span class="glyphicon glyphicon-remove-sign"></span>
              </a>
          </li>
      </ul>

      <div class="clearfix"></div>
  </div>
</template>
<script>
  import { store } from './../store.js';
  import { shared } from './../shared.js';

  export default {
      props: ['filters'],
      mixins: [shared],
      methods: {
          clearFilters: function (event) {
              event.preventDefault();
              store.filter(true);
          },
          removeFilter: function (filter, event) {
              event.preventDefault();
              store.removeFilter(filter);
          }
      },
      computed: {
          showFilters: function () {
              return this.filters.length > 0;
          }
      }
  }
</script>